import { PhnxImageHolder } from '../ImageHolder/ImageHolder'
import styles from './Ticker.module.css'

export type TickerProps = {
  title: string
  items: {
    title?: string
    asset: {
      src: string
      alt: string
    }
  }[]
  title_position: 'left' | 'center' | 'right'
}

export const PhnxTicker: React.FC<TickerProps> = ({ title, items, title_position }) => {
  return (
    <div className={`container ${styles['ticker']}`}>
      <div className={styles['inner-container']} data-title-position={title_position}>
        <div className={styles.title}>{title && <p>{title}</p>}</div>
        <div className={styles.slider}>
          <div className={styles['container']}>
            {items &&
              items.length > 0 &&
              items.map((item, index) => (
                <div className={styles['slide']} key={'set1-' + index}>
                  <PhnxImageHolder images={[item.asset]} />
                </div>
              ))}
            {items &&
              items.length > 0 &&
              items.map((item, index) => (
                <div className={styles['slide']} key={'set2-' + index}>
                  <PhnxImageHolder images={[item.asset]} />
                </div>
              ))}
            {items &&
              items.length > 0 &&
              items.map((item, index) => (
                <div className={styles['slide']} key={'set3-' + index}>
                  <PhnxImageHolder images={[item.asset]} />
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  )
}
